import { CommonState } from './common';

export enum DisablePaymentPlatforms {
  ANDROID = 'android',
  IOS = 'ios',
  HUAWEI = 'huawei',
  WEB = 'web',
  NATIVE_IOS = 'native-ios',
  NATIVE_ANDROID = 'native-android',
  NATIVE_HUAWEI = 'native-huawei',
}

export enum DisablePaymentPlatformsVersion {
  ANDROID_VER = 'android-ver',
  IOS_VER = 'ios-ver',
  HUAWEI_VER = 'huawei-ver',
  WEB_VER = 'web-ver',
  NATIVE_IOS_VER = 'native-ios-ver',
  NATIVE_ANDROID_VER = 'native-android-ver',
  NATIVE_HUAWEI_VER = 'native-huawei-ver',
}

export const DISABLE_PAYMENT_PLATFORMS: Record<DisablePaymentPlatforms, DisablePaymentPlatforms> &
  Record<DisablePaymentPlatformsVersion, DisablePaymentPlatformsVersion> = {
  [DisablePaymentPlatforms.ANDROID]: DisablePaymentPlatforms.ANDROID,
  [DisablePaymentPlatformsVersion.ANDROID_VER]: DisablePaymentPlatformsVersion.ANDROID_VER,
  [DisablePaymentPlatforms.IOS]: DisablePaymentPlatforms.IOS,
  [DisablePaymentPlatformsVersion.IOS_VER]: DisablePaymentPlatformsVersion.IOS_VER,
  [DisablePaymentPlatforms.HUAWEI]: DisablePaymentPlatforms.HUAWEI,
  [DisablePaymentPlatformsVersion.HUAWEI_VER]: DisablePaymentPlatformsVersion.HUAWEI_VER,
  [DisablePaymentPlatforms.WEB]: DisablePaymentPlatforms.WEB,
  [DisablePaymentPlatformsVersion.WEB_VER]: DisablePaymentPlatformsVersion.WEB_VER,
  [DisablePaymentPlatforms.NATIVE_IOS]: DisablePaymentPlatforms.NATIVE_IOS,
  [DisablePaymentPlatformsVersion.NATIVE_IOS_VER]: DisablePaymentPlatformsVersion.NATIVE_IOS_VER,
  [DisablePaymentPlatforms.NATIVE_ANDROID]: DisablePaymentPlatforms.NATIVE_ANDROID,
  [DisablePaymentPlatformsVersion.NATIVE_ANDROID_VER]:
    DisablePaymentPlatformsVersion.NATIVE_ANDROID_VER,
  [DisablePaymentPlatforms.NATIVE_HUAWEI]: DisablePaymentPlatforms.NATIVE_HUAWEI,
  [DisablePaymentPlatformsVersion.NATIVE_HUAWEI_VER]:
    DisablePaymentPlatformsVersion.NATIVE_HUAWEI_VER,
} as const;

export interface DisablePayment {
  data: Record<DisablePaymentPlatforms, 1 | 0> & Record<DisablePaymentPlatformsVersion, string>;
}

export type DisablePaymentState = CommonState & {
  disablePayment: DisablePayment | null;
};
